export default "__VITE_ASSET__B$eVQt0L__"